/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCustomArticleHeader = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M2 11h8v2H2zm0 3h8v2H2zm0 3h8v2H2zm0 3h8v2H2zm10 0h10v2H12zM2 2v7h20V2zm18 5H4V4h16zm-8 4h10v2H12zm0 6h10v2H12zm0-3h10v2H12z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgCustomArticleHeader as CustomArticleHeader };
